import { widgetApi } from "../services/api";

/**
 * Typed wrappers over `/widget/catalog/*` for progressive cash-pickup discovery
 * (states + payers). The `x-link-id` header is injected by `widgetApi`.
 */

export type EffectiveStatus = "AVAILABLE" | "UNAVAILABLE";

export interface PayerCapability {
  payerCode: string;
  displayName: string;
  countryCode: string;
  payoutMethods: string[];
  supportedByCorridors: string[];
  effectiveStatus: EffectiveStatus;
  instructions?: string;
  accountPrefixes?: string[];
  constraints?: Record<string, unknown>;
}

export interface StateCapability {
  countryCode: string;
  stateCode: string;
  stateName: string;
  payoutMethods: string[];
  payerCodes?: string[];
  supportedByCorridors: string[];
  effectiveStatus: EffectiveStatus;
}

interface CatalogListResponse<T> {
  success: boolean;
  data: { items: T[] };
}

const toQueryString = (params: object): string => {
  const usp = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null || value === "") continue;
    usp.set(key, String(value));
  }
  const s = usp.toString();
  return s ? `?${s}` : "";
};

export interface CatalogPayersInput {
  originCountryCode?: string;
  destinationCountryCode: string;
  stateCode?: string;
  cityCode?: string;
  payoutMethod?: string;
  fundingMethod?: string;
  includeUnavailable?: boolean;
}

export const getCatalogPayers = async (
  input: CatalogPayersInput
): Promise<PayerCapability[]> => {
  const { data } = await widgetApi.get<CatalogListResponse<PayerCapability>>(
    `/widget/catalog/payers${toQueryString(input)}`
  );
  return data.data.items;
};

export interface CatalogStatesInput {
  originCountryCode?: string;
  payoutMethod?: string;
  payerCode?: string;
  fundingMethod?: string;
  includeUnavailable?: boolean;
}

export const getCatalogStates = async (
  countryCode: string,
  input: CatalogStatesInput = {}
): Promise<StateCapability[]> => {
  const { data } = await widgetApi.get<CatalogListResponse<StateCapability>>(
    `/widget/catalog/countries/${countryCode}/states${toQueryString(input)}`
  );
  return data.data.items;
};
